import React, { Suspense, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { authActions } from "../../store/state-slices/auth";
const Authorize = (props) => {
  const { Component } = props;
  const NewComponent = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    useEffect(() => {
      if (localStorage.authToken && localStorage.refreshToken) {
        dispatch(authActions.setLogin());
      } else {
        // navigate("/auth/signin");
        window.location.href = process.env.REACT_APP_JIOCLOUD_HOME_URL;
      }
    }, []);

    return (
      //   <Suspense fallback={<Loader loading={true} />}>{
      Component
      // }</Suspense>
    );
  };

  return <NewComponent />;
};

export default Authorize;
